import InvoiceRequest from '@models/requests/invoice-request.model';
import { createAction, props } from '@ngrx/store';

export const enum InvoiceActionTypes {
  createInvoice = '[invoice] CREATE_AND_DOWNLOAD_INVOICE',
  createInvoiceSuccess = '[invoice] CREATE_INVOICE_SUCCESS',
}

export const createInvoice = createAction(
  InvoiceActionTypes.createInvoice,
  props<{ payload?: InvoiceRequest }>(),
);